import instance from "services/axios.base";

const getPermissions = async () => {
  const res = await instance.get("/service?name=role&tablename=hr_employee");
  return res.data;
};

export { getPermissions };
